/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class ComplianceRequirementsService {

    /**
     * Requests the compliance requirement catalog
     * Returns the account's WX compliance requirement catalog (uuid and name), used to resolve requirement names in compliance status label tooltips
     * @returns any successful
     * @throws ApiError
     */
    public static getInternalApiComplianceRequirements(): CancelablePromise<{
        requirements: Array<{
            uuid: string;
            name: string;
        }>;
    }> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/internal_api/compliance_requirements',
        });
    }

}